import { RewardInterface } from "../../../home/domain/interface/reward_interface";
import { RewardRepository } from "../../domain/repository/reward_repository";
import { RewardApiService } from "../data_source/reward_api_service";


export class RewardRepositoryImpl implements RewardRepository {
    private rewardApiService: RewardApiService;

    constructor() {
        this.rewardApiService = new RewardApiService();
    }

    async getRepeatableRewards(experience: number): Promise<RewardInterface[] | null> {
        const response = await this.rewardApiService.getRepeatableRewards();

        if (response.status === 200) {
            const rewards: RewardInterface[] = [];
            for (const reward of response.data) {
                const id = reward['_id'] as string;
                const name = reward['name'] as string;
                const expValue = reward['expValue'] as number;
                const nbEarned = Math.floor(experience / expValue);
                for (let i = 0; i < nbEarned; i++) {
                    rewards.push({
                        id: id,
                        name: name,
                        level: expValue * (i + 1),
                        userReward: { earned: true },
                    })
                }

                for (let i = nbEarned; i < nbEarned + 3; i++) {
                    rewards.push({
                        id: id,
                        name: name,
                        level: expValue * (i + 1),
                        userReward: { earned: false },
                    });
                }
            }
            rewards.sort((a, b) => a.level - b.level);
            return rewards;
        }
        return null;
    }

    async getExceptionalRewards(skip: number, limit: number, filters: string[]): Promise<{ rewards: RewardInterface[], fetchedAll: boolean}> {
        const response = await this.rewardApiService.getExceptionalRewards(skip, limit, filters);

        if (response.status === 200) {
            const rewards: RewardInterface[] = [];
            for (const reward of response.data.objects) {
                rewards.push({
                    id: reward['_id'] as string,
                    name: reward['name'] as string,
                    level: reward['expValue'] as number,
                    expGained: reward['expGained'] as number,
                    picture: reward['picture'] as string | undefined,
                    startDate: reward['startDate'] ? new Date(reward['startDate']) : undefined,
                    endDate: reward['endDate'] ? new Date(reward['endDate']) : undefined,
                    userReward: reward['userReward'] != null
                        ? {
                            earned: reward['userReward']['claimed'] as boolean,
                            id: reward['userReward']['_id'] as string
                        } : { earned: true, id: undefined },
                    description: reward['description'] as string | undefined,
                    address: reward['location'] as string | undefined,
                });
            }
            return { rewards, fetchedAll: response.data.pages <= (skip / limit) + 1 };
        }
        throw new Error('Failed to fetch exceptional rewards');
    }
}